<template>
  <div class="modal-card" style="width: auto; max-width: 800px; margin: auto;">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("lockerDelivery.updateInfo") }}
      </p>
    </header>

    <section class="modal-card-body">
      <h2 class="subtitle" style="margin-bottom: 0.8rem;">
        {{ $t(`lockerDelivery.client`) }}
        <b-icon icon="user" style="position: relative; top: 2px;"></b-icon>
      </h2>

      <div class="columns" style="margin-top: 0.8rem;">
        <div class="column">
          <b-field
            :label="$t('lockerDelivery.name')"
            label-position="on-border"
          >
            <b-input v-model="clientName"></b-input>
          </b-field>
        </div>

        <div class="column">
          <b-field
            :label="$t('lockerDelivery.personalId')"
            label-position="on-border"
          >
            <b-input
              v-model="clientPersonalId"
              @input.native="
                clientPersonalId = formatPersonalId('clientPersonalId')
              "
            ></b-input>
          </b-field>
        </div>
      </div>

      <div v-if="lockerDelivery.courier">
        <hr />
        <h2 class="subtitle" style="margin-bottom: 0.8rem;">
          {{ $t(`lockerDelivery.courier`) }}
          <b-icon
            icon="motorcycle"
            style="position: relative; top: 4px;"
          ></b-icon>
        </h2>

        <div class="columns" style="margin-top: 0.8rem;">
          <div class="column">
            <b-field
              :label="$t('lockerDelivery.name')"
              label-position="on-border"
            >
              <b-input v-model="courierName"></b-input>
            </b-field>
          </div>

          <div class="column">
            <b-field
              :label="$t('lockerDelivery.personalId')"
              label-position="on-border"
            >
              <b-input
                v-model="courierPersonalId"
                @input.native="
                  courierPersonalId = formatPersonalId('courierPersonalId')
                "
              ></b-input>
            </b-field>
          </div>
        </div>
      </div>

      <hr />
      <b-field
        :label="$t('lockerDelivery.observations')"
        label-position="on-border"
      >
        <b-input v-model="observations"></b-input>
      </b-field>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>

      <button
        class="button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        type="button"
        @click="updateInfo"
      >
        {{ $t("lockerDelivery.update") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";

export default {
  props: ["lockerDelivery"],

  mixins: [common, mask],

  data() {
    return {
      isLoading: false,
      clientName: "",
      clientPersonalId: "",
      courierName: "",
      courierPersonalId: "",
      observations: ""
    };
  },

  methods: {
    updateInfo() {
      this.isLoading = true;
      const info = {
        deliveryId: this.lockerDelivery._id,
        clientName: this.clientName,
        clientPersonalId: this.clientPersonalId,
        courierName: this.lockerDelivery.courier ? this.courierName : undefined,
        courierPersonalId: this.lockerDelivery.courier
          ? this.courierPersonalId
          : undefined,
        observations: this.observations
      };
      this.$store
        .dispatch("updateDeliveryInfo", info)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$emit("info-updated", info);
            this.$buefy.toast.open({
              message: this.$t("lockerDelivery.infoUpdated"),
              type: "is-primary",
              position: "is-bottom",
              duration: 5000
            });
            this.$parent.close();
          }
        })
        .catch(err => {
          this.alertError(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  mounted() {
    this.clientName = this.lockerDelivery.client.personalInfo.name;
    this.clientPersonalId = this.lockerDelivery.client.personalInfo.personalId;
    this.observations = this.lockerDelivery.observations;

    if (this.lockerDelivery.courier) {
      this.courierName = this.lockerDelivery.courier.personalInfo.name;
      this.courierPersonalId = this.lockerDelivery.courier.personalInfo.personalId;
    }
  }
};
</script>

<style scoped>
section {
  padding-bottom: 2rem;
}
</style>
